document.addEventListener('DOMContentLoaded', () => {
  const backLinkSelector = '.product__back-link';
  const chatButtonSelector = '.chat-floating-button';
  const productMediaSelector = '.product__media-wrapper';
  const blocksContainerSelector = '.product__info-container';
  const initialStateClassname = 'product-group--initial';
  const mainInfoSelector = '.product-group__1';
  const productSwiperSelector = '#product-gallery-swiper';
  const sizeSelectSelector = '.product-group__3';

  const chatInitialBottom =
    window.innerHeight - document.querySelector(chatButtonSelector)?.getBoundingClientRect().bottom || 0;

  let productGallerySwiper = null;

  function calculateMainInfoBottom() {
    if (isDesktop()) {
      return;
    }
    const productBlocks1 = document.querySelector(mainInfoSelector);
    const productBlocks3 = document.querySelector(sizeSelectSelector);
    if (productBlocks1 && productBlocks3) {
      productBlocks1.style.bottom = `${productBlocks3.offsetHeight}px`;
      productBlocks3.style.bottom = 0;
    }
  }

  function calculateBackLinkPosition() {
    const backLink = document.querySelector(backLinkSelector);
    if (backLink) {
      const height = getHeaderHeight();
      backLink.style.top = `${height}px`;
    }
  }

  function calculateChatButtonPosition() {
    const chatButton = document.querySelector(chatButtonSelector);
    const productMedia = document.querySelector(productMediaSelector);
    if (chatButton && productMedia) {
      if (isDesktop()) {
        chatButton.style.bottom = `${chatInitialBottom}px`;
        chatButton.style.position = 'fixed';
      } else {
        const height = productMedia.getBoundingClientRect().height;
        const bottom = window.innerHeight - height + chatInitialBottom;
        chatButton.style.bottom = `${bottom}px`;
        chatButton.style.position = 'absolute';
      }
    }
  }

  function toggleProductBottomBarFixed() {
    if (isDesktop()) {
      return;
    }
    const productBlocksContainer = document.querySelector(blocksContainerSelector);
    const productBlocks1 = document.querySelector(mainInfoSelector);
    const productBlocks3 = document.querySelector(sizeSelectSelector);
    if (productBlocksContainer && productBlocks1 && productBlocks3) {
      const topPositionToReach = window.innerHeight - productBlocks1.offsetHeight - productBlocks3.offsetHeight;
      const fixedBlockGroupsReached = (productBlocksContainer.getBoundingClientRect().top <= topPositionToReach);
      if (fixedBlockGroupsReached) {
        productBlocks1.classList.add(initialStateClassname);
        productBlocks3.classList.add(initialStateClassname);
      } else {
        productBlocks1.classList.remove(initialStateClassname);
        productBlocks3.classList.remove(initialStateClassname);
      }
    }
  }

  function createSwiper() {
    if (productGallerySwiper) {
      return;
    }
    productGallerySwiper = new Swiper(productSwiperSelector, {
      allowTouchMove: true,
      direction: 'horizontal',
      grabCursor: true,
      spaceBetween: 0,
      speed: 500,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
      },
      on: {
        init() {
          this.params.loop = true;
        },
      },
    });
  }

  function destroySwiper() {
    if (!productGallerySwiper) {
      return;
    }
    productGallerySwiper.destroy();
    productGallerySwiper = null;
  }

  function initializeProduct() {
    calculateMainInfoBottom();
    calculateBackLinkPosition();
    calculateChatButtonPosition();
    toggleProductBottomBarFixed();
    addToWishlistEvent(document.querySelector('.product'));
    if (isDesktop()) {
      destroySwiper();
    } else {
      createSwiper();
    }
  }

  window.addEventListener('scroll', () => {
    toggleProductBottomBarFixed();
  });

  window.addEventListener(
    'resize',
    debounce(() => {
      initializeProduct();
    }, 1000),
  );

  document.body.addEventListener('variant:change', initializeProduct);

  initializeProduct();
});
